import { render, staticRenderFns } from "./IRLExplainModal.vue?vue&type=template&id=32aab83d&scoped=true&"
import script from "./IRLExplainModal.vue?vue&type=script&lang=js&"
export * from "./IRLExplainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aab83d",
  null
  
)

export default component.exports